import React, { useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Button, Card, CardBody, Col, Row } from "reactstrap"
import disputeImg1 from "../../../assets/images/disputes/dispute-1.png"
import DisputeHistory from "./components/DisputeHistory"
import { useTranslation } from "react-i18next"

const disputeDetails = {
  id: "ID-254832555",
  title: "Dispute Title",
  createdAt: "2025-08-27",
  createdBy: "Amr Kamal",
  createdPhoto: "https://placehold.co/30x30/png",
  description:
    "description goes here Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla luctus libero urna, at mattis lectus varius at. Cras facilisis purus ipsum, non commodo arcu imperdiet sit amet. Donec bibendum ante eu placerat condimentum.",
  image: [disputeImg1, disputeImg1, disputeImg1, disputeImg1],
  disputeHistory: [
    {
      date: "2 jan, 2024 at 10:00 aM.",
      status: "forward dispute to admin",
    },
    {
      date: "30 dec, 2023 at 1:00 pM.",
      status: "delivery attached images",
    },
    {
      date: "30 dec, 2023 at 1:00 pM.",
      status: "you attached images",
    },
    {
      date: "25 dec, 2023 at 11:00 aM.",
      status: "you send response",
    },
    {
      date: "23 dec, 2023 at 10:00 aM.",
      status: "Dispute created",
    },
  ],
}

const DisputeDetails = () => {
  const { t } = useTranslation()

  const [copied, setCopied] = useState(false)
  const [openAccordion, setOpenAccordion] = useState(true)

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 1500)
    })
  }
  return (
    <div className="page-content">
      <div className="container-fluid d-flex justify-content-between align-items-center">
        <Breadcrumbs
          title={t("dashboard_dashboard")}
          breadcrumbItem={t("disputes_disputes")}
        />
        <div className="d-flex gap-2">
          <Button
            onClick={() => {}}
            className="bg-gradiant-blue border-0 text-capitalize"
          >
            {t("disputes_forward")}
          </Button>
          <Button
            onClick={() => {}}
            className="bg-white border-1 text-primary border-primary"
          >
            {t("disputes_escalated")}
          </Button>
          <Button
            onClick={() => {}}
            className="bg-transparent border text-danger border-danger text-capitalize"
          >
            {t("disputes_rejectDispute")}
          </Button>
        </div>
      </div>
      <Card className="shadow-md rounded-3">
        <CardBody>
          <Row className="justify-content-between">
            <Col md={4} className="d-flex flex-column align-items-start gap-1">
              <h4 className="fw-bold medium text-capitalize mb-0">
                {disputeDetails.title}
              </h4>
              <div className="d-flex align-items-center gap-2">
                <p className="text-muted m-0">
                  <span className="fw-semibold font-size-14 text-semi-dark">
                    {t("disputes_disputeID")}:
                  </span>
                  <span className="mx-2">{disputeDetails.id}</span>
                </p>
                <button
                  className="relative cursor-pointer border-0 bg-transparent"
                  onClick={() => {
                    copyToClipboard(disputeDetails.id)
                  }}
                >
                  <i className="bx bx-copy px-2 text-primary bx-sm cursor-pointer"></i>
                  {copied && (
                    <span
                      className="position-absolute  translate-middle-x mt-1 text-success small"
                      style={{ top: "14px", marginLeft: "20px" }}
                    >
                      {t("common_copied")}
                    </span>
                  )}
                </button>
              </div>
            </Col>
            <Col md={4}>
              <p className="text-muted my-1">
                <span className="fw-semibold font-size-14 text-semi-dark">
                  {t("common_createdAt")}:
                </span>
                <span className="mx-2">{disputeDetails.createdAt}</span>
              </p>
              <p className="text-muted m-0">
                <span className="fw-semibold font-size-14 text-semi-dark">
                  {t("common_createdBy")}:
                </span>
                <span className="mx-2">
                  <img
                    src={disputeDetails.createdPhoto}
                    alt=""
                    className="rounded-circle mx-2"
                  />
                  {disputeDetails.createdBy}
                </span>
              </p>
            </Col>
            <Col
              md={4}
              className="d-flex flex-column align-items-start gap-1 justify-content-center align-items-center"
            >
              <Button
                onClick={() => {}}
                className="bg-gradiant-blue border-0 text-capitalize w-50"
              >
                {t("disputes_approveRefund")}
              </Button>
              <Button
                onClick={() => {}}
                className="bg-white border-1 text-primary border-primary w-50"
              >
                {t("disputes_respondToDispute")}
              </Button>
            </Col>
          </Row>
          <p className="border-bottom border-top p-2 mt-4">
            {disputeDetails.description}
          </p>
          <div className="mt-2">
            <h5 className="fw-semibold font-size-14 text-semi-dark">
              {t("common_attachments")}:
            </h5>
            {disputeDetails.image.map((image, index) => (
              <img key={index} src={image} alt="" className="m-2" />
            ))}
          </div>
        </CardBody>
      </Card>

      <Card className="shadow-md rounded-3 mt-2">
        <CardBody>
          <DisputeHistory
            openAccordion={openAccordion}
            setOpenAccordion={setOpenAccordion}
            disputeHistory={disputeDetails.disputeHistory}
          />
        </CardBody>
      </Card>
    </div>
  )
}

export default DisputeDetails
